<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Banner Images</label>
          <div class="group-item">
            <div>
              <v-checkbox v-model="fields.banner.useBannerMobile" label="Use banner mobile" hide-details />
              <div class="mb-3" v-if="fields.banner.useBannerMobile">
                <UploadImage
                  @callback="handleUploadBannerMobile"
                  :image="{ imageSrc: fields.banner.mobile }"
                  :height="`160`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveBannerMobile"
                />
              </div>
            </div>
            <div>
              <UploadImage
                @callback="handleUploadBannerDesktop"
                :image="{ imageSrc: fields.banner.desktop }"
                :height="`160`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveBannerDesktop"
              />
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Content Wrapper</label>
          <div class="group-item">
            <v-text-field
              v-model.number="fields.wrapContent.widthContent"
              type="number"
              label="Content width"
              min="0"
              suffix="px"
              hide-details
            />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Heading</label>
            <input type="checkbox" v-model="fields.heading.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.heading.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <DividerPrimary :divider="fields.divider" />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Description</label>
            <input type="checkbox" v-model="fields.description.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.description.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Small Image</label>
            <input type="checkbox" v-model="fields.smallImage.show" />
          </div>
          <div class="group-item">
            <UploadImage
              @callback="handleUploadSmallImage"
              :image="{ imageSrc: fields.smallImage.src }"
              :height="`120`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveSmallImage"
            />
            <!-- <v-text-field v-model="fields.smallImage.alt" class="mt-3" label="Alt" hide-details /> -->
          </div>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import DividerPrimary from './common/divider-primary.vue';
import ButtonPrimary from './common/button-primary.vue';

export default {
  name: 'card-banner-02-rivoneed-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    DividerPrimary,
    ButtonPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      alignOptions: ['left', 'center', 'right'],
      fields: {
        title: 'Card Banner 02 Rivoneed Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        banner: {
          useBannerMobile: true,
          desktop: '',
          mobile: '',
        },
        wrapContent: {
          widthContent: 625,
        },
        heading: {
          show: true,
          content:
            '<h2>Evaluated by Professional Technicians</h2><p>Designed and tested to meet everyday repair needs.</p>',
        },
        divider: {
          show: true,
          maxWidth: 48,
          height: 4,
          backgroundColor: '#ffffff4d',
          align: 'left',
        },
        description: {
          show: true,
          content:
            '<p>"This magnetic light bar solves the core problem of handheld flashlights-hands-free, stable light is what makes repairs actually efficient."</p><p>- David Torres, ASE-Certified Automotive Technician</p>',
        },
        smallImage: {
          show: true,
          src: '',
          alt: '',
        },
        button: {
          show: false,
          backgroundColor: '#ff0000',
          color: '#FFFFFF',
          radius: 4,
          text: 'Buy Now',
          link: '#',
          iconPrefix: {
            show: false,
            src: '',
          },
          iconSuffix: {
            show: true,
            src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
          },
          subBtn: {
            show: false,
            text: '',
          },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        banner: { ...this.fields.banner, ...(extract.banner || {}) },
        wrapContent: { ...this.fields.wrapContent, ...(extract.wrapContent || {}) },
        heading: { ...this.fields.heading, ...(extract.heading || {}) },
        divider: { ...this.fields.divider, ...(extract.divider || {}) },
        description: { ...this.fields.description, ...(extract.description || {}) },
        smallImage: { ...this.fields.smallImage, ...(extract.smallImage || {}) },
        button: { ...this.fields.button, ...(extract.button || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardBanner02Rivoneed(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadBannerDesktop(obj) {
      this.fields.banner.desktop = obj.imageSrc || '';
    },
    handleRemoveBannerDesktop() {
      this.fields.banner.desktop = '';
    },
    handleUploadBannerMobile(obj) {
      this.fields.banner.mobile = obj.imageSrc || '';
    },
    handleRemoveBannerMobile() {
      this.fields.banner.mobile = '';
    },
    handleUploadSmallImage(obj) {
      this.fields.smallImage.src = obj.imageSrc || '';
    },
    handleRemoveSmallImage() {
      this.fields.smallImage.src = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
